module.exports = __webpack_public_path__ + "img/map.0ea02098.jpg";